<template>
  <div class="heroBlock">
    <v-carousel hide-delimiters cycle>
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      >
        <v-row
          class="fill-height hidden-xs-only"
          align="center"
          justify="center"
        >
          <div class="display-3 white--text">{{ item.title }}</div>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  name: "Hero",
  data() {
    return {
      items: [
        {
          src: require("../assets/images/02carousel.jpg"),
          title: "Добре дошли в " + "къща за гости Никол!",
        },
        {
          src: require("../assets/images/03carousel.jpg"),
          title: "на топ локация в центъра на гр.Хисаря",
        },
        {
          src: require("../assets/images/04carousel.jpg"),
          title: "и предлага на своите гости удобство и уют.",
        },
        {
          src: require("../assets/images/05carousel.png"),
          title: "тел: 0895156101",
        },
      ],
    };
  },
};
</script>

